export default __webpack_public_path__ + "static/media/ic_uni_arbitrum.515e9e0a.svg";